import styled from 'styled-components'

interface IAppHeaderSelectStyledProps {}

export const AppHeaderSelectStyled = styled.div<IAppHeaderSelectStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  min-width: ${(props) => props.theme.typography.pxToRem(200)};
`
